module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/opt/build/repo/src/layouts/index.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"amc-investment-company-website","short_name":"AMCINVEST","start_url":"/","background_color":"#fff","theme_color":"#fff","display":"standalone","crossOrigin":"use-credentials","icon":"src/assets/images/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"f39664993ab7ec46b0a603d3336f5ff0"},
    }]
